import { AppBar } from 'components/AppBar/AppBar';
import WelcomeModal from 'components/Modal/WelcomeModal';
import { useWelcomeModal } from 'components/Modal/WelcomeModalContext';
import { Content, ContentInner, Main } from 'components/Page/styles';
import SnomedBar from 'components/Snomed/SnomedBar';
import { FadeInFadeOut, ToastContainer, ToastContainerWrapper } from 'components/Toast/styles';
import { TopBar } from 'components/TopBar';
import { STRINGS } from 'config';
import { ReactNode, useEffect, useState } from 'react';
import { getCurrentUser } from 'store/action/auth';
import { useAppDispatch, useAppState } from 'store/configureStore';
import { useRefreshTimer } from '../../util/customHooks';
import './force-scrollbar.css';

interface PageProps {
  children: ReactNode;
}

const Page = (props: PageProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const {
    app,
    wallet: { subscription },
    featureFlags: { TEMP_SUMMARISER_PAYMENT_ENABLED, ENABLE_SHOW_WELCOME_MODAL },
  } = useAppState();
  const dispatch = useAppDispatch();
  const { children } = props;

  useEffect(() => {
    getCurrentUser(dispatch).then(authenticationSuccessful => {
      setIsAuthenticated(authenticationSuccessful);
    });
  }, [dispatch]);

  const refreshTokensEnabled = isAuthenticated && !app.roles.includes(STRINGS.TOOLBAR.ROLE);
  useRefreshTimer(
    dispatch,
    STRINGS.SESSION.REFRESH_AFTER,
    STRINGS.SESSION.LOGOUT_AFTER,
    STRINGS.SESSION.REFRESH_INTERVAL,
    refreshTokensEnabled,
  );
  const canUseApp = TEMP_SUMMARISER_PAYMENT_ENABLED || subscription;

  const { isWelcomeModalOpen, closeWelcomeModal } = useWelcomeModal();

  return (
    // isAuthenticated &&
    <>
      <TopBar />
      <Main>
        <AppBar />
        <Content className="force-scrollbar">
          <ContentInner>{children}</ContentInner>
        </Content>
        {canUseApp && <SnomedBar />}
        <ToastContainerWrapper>
          <ToastContainer
            position="bottom-left"
            closeOnClick={false}
            closeButton={false}
            pauseOnFocusLoss={false}
            autoClose={3000}
            theme="dark"
            transition={FadeInFadeOut}
            hideProgressBar
            pauseOnHover
            newestOnTop
          />
        </ToastContainerWrapper>
      </Main>
      {ENABLE_SHOW_WELCOME_MODAL && <WelcomeModal isOpen={isWelcomeModalOpen} onClose={closeWelcomeModal} />}
    </>
  );
};

export default Page;
